import Hero from './EntryPage';
import { useState } from 'react';
import { useLanguage } from '../i18n/LanguageContext';
import { useGenericEffect } from '../components/UseGenericEffect';
import UnderConstruction from '../components/UnderConstruction';

export default function Partners() {
  const { strings } = useLanguage();
  const map = {};  
  const [message, setMessage] = useState('');


  
  const partnersData = [
    {
      id: 'siil',
      tag: "Swiss International Institute Lausanne (SIIL)",
      about: 'RPSWISS И SIIL: ПАРТНЁРСТВО В СФЕРЕ ОБРАЗОВАНИЯ И ПРОФЕССИОНАЛЬНОГО РАЗВИТИЯ',
      logo: '/img/siil_logo.png',
      link: 'https://siil.ch/ru/',
      paragraphs: [
        'В июне 2026 года Association des Professionnels Russophones de Suisse (RPSwiss) и Swiss International Institute Lausanne (SIIL) заключили партнёрское соглашение. Подписание состоялось в кампусе SIIL в Прийи, кантон Во.',
        'Сотрудничество с SIIL расширяет образовательные возможности для членов RPSwiss и поддерживает одно из ключевых направлений деятельности ассоциации — профессиональное развитие русскоязычных специалистов, предпринимателей, руководителей и экспертов, живущих и работающих в Швейцарии.',
        'Партнёрство предусматривает развитие совместных образовательных и экспертных инициатив, проведение профессиональных мероприятий, а также подготовку материалов и проектов, отвечающих актуальным запросам русскоязычного сообщества в Швейцарии.',
        'Члены RPSwiss получают скидку 20% на образовательные программы SIIL.'  ]
        
    },
    {
      id: 'mf',
      tag: "МИХАИЛ ФИЛЯЕВ",
      about: 'ЭКСПЕРТНЫЙ ПАРТНЁР RPSWISS',
      logo: '/img/filaev_bust.png',
      link: 'https://mfilyaev.com/',
      paragraphs: [
      'Михаил Филяев — гранд-доктор философии (GPhD), основатель метода PSY2.0 и экспертный партнёр RPSwiss.',
      'Сотрудничество строится вокруг обмена знаниями и развития экспертных и образовательных инициатив для русскоязычного профессионального сообщества.',
      'Экспертиза Михаила Филяева дополняет направления деятельности ассоциации, связанные с личностным и профессиональным развитием.',
      'Для участников RPSwiss это возможность знакомиться с новыми подходами, расширять профессиональный взгляд и получать практические знания от признанного эксперта.'
      ]
        
    },
    {
      id: 'saederis',
      tag: "SADERIS GROUP GMBH",
      about: 'СТРАТЕГИЧЕСКИЙ ПАРТНЁР RPSWISS',
      logo: '/img/SaDerisGroupGmbH.png',
      link: 'https://www.saderis.ch',
      paragraphs: [
      'SaDeris Group GmbH - консалтинговая компания, оказывающая поддержку частным лицам и бизнесу по вопросам HR, расчёта заработной платы, налогообложения, бухгалтерии и административных процедур в Швейцарии.',
      'Партнёрство с SaDeris Group расширяет доступ участников RPSwiss к профессиональной экспертизе и практическим решениям, помогающим ориентироваться в швейцарской системе и развивать бизнес.',
      'Для членов RPSwiss действуют специальные условия: первая консультация продолжительностью 30 минут предоставляется бесплатно, а на последующие консультации действует скидка 10%.',
      'Сотрудничество с SaDeris Group дополняет направления деятельности ассоциации, связанные с профессиональным развитием и поддержкой русскоязычных специалистов, предпринимателей и руководителей в Швейцарии'
      ]
        
    }
  ];
  

  return (
    <div className="main">
      <div className="content-wrapper">
        
        {/* Hero Section */}
        <section className="section">
          <div className="section-tag">
            {strings?.pages?.partners?.eyebrow || 'Партнеры'}
          </div>
          <div className="event_hero partners-hero">
            <div className="event_hero__content partners-hero__content">
              <h1 className="event_hero__title">
                Наши <em className="event_hero__title-accent">партнеры</em>
              </h1>
              <p className="event_hero__subtitle">
                RPSwiss — некоммерческая ассоциация, и партнёрства являются важной частью её развития.
                <br /><br />
                Мы объединяем вокруг ассоциации образовательные учреждения, компании, экспертов и профессиональные
                сообщества, чья экспертиза и ресурсы могут создавать дополнительную ценность для наших участников.
                <br /><br />
                Для RPSwiss партнёрство — это не просто сотрудничество между организациями. Это возможность объединять знания и опыт, 
                создавать совместные образовательные и профессиональные инициативы, расширять доступ участников к экспертизе и формировать 
                специальные условия для членов ассоциации.
                <br /><br />
                Мы стремимся развивать долгосрочные партнёрства, которые приносят практическую пользу нашему 
                профессиональному сообществу и способствуют его развитию в Швейцарии.
             
              </p>
            </div>

            <div className="event_hero__media">
              <div className="event_hero__overlay" />
              <img
                src='/img/bg_partners.avif'
                alt="RPSwiss Partners"
                className="event_hero__image"
              />
            </div>
          </div>
        </section>
        {/* Partners Catalog Section */}
        {partnersData.map((partner) => (
          <section key={partner.id} className="partners-catalog-section section">
            <div className="section-tag">{partner.tag}</div>
            
            <div className="partners-grid">
              {/* Card Wrapper */}
              <div className="card-blue partner-card">
                
                {/* Header Row: Title on Left, Logo on Right */}
                <div className="partner-card__header-row">
                  <h2 className="card-blue__title partner-card__title">
                    {partner.about}
                    <div className="card-blue__divider partner-card__divider" />
                  </h2>

                  {partner.logo && (
                    <img
                      src={partner.logo}
                      alt={`${partner.tag} logo`}
                      className="partner-card__logo"
                    />
                  )}
                </div>

         

                {/* Paragraphs spanning full width inside card */}
                <div className="partner-card__paragraphs">
                  {partner.paragraphs.map((paragraph, index) => (
                    <p 
                      key={index}
                      className="event_hero__subtitle"
                    >
                      {paragraph}
                    </p>
                  ))}
                </div>

                {/* Right-aligned Button inside Card */}
                {partner.link && (
                  <div className="partner-card__button-wrap">
                    <a 
                      href={partner.link} 
                      target="_blank" 
                      rel="noreferrer" 
                      className="btn btn-dark"
                    >
                      Перейти на сайт
                    </a>
                  </div>
                )}

              </div>
            </div>
          </section>
        ))}
       
      </div>
    </div>
  );
}